import { render, staticRenderFns } from "./AccountExpired.vue?vue&type=template&id=1407eabe&"
import script from "./AccountExpired.vue?vue&type=script&lang=js&"
export * from "./AccountExpired.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports